var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UserType } from "healthex-common/user.dtos";
import { computed, observable } from "mobx";
import { NOT_LOADED } from "../../Infra/RemoteData";
import { GlobalAdminOrganizationFormModelBase } from "./GlobalAdminOrganizationFormModelBase";
import { BlockchainSigningType } from "healthex-common/blockchain.dtos";
export class GlobalAdminHealthcareOrganizationFormModel extends GlobalAdminOrganizationFormModelBase {
    constructor(opts) {
        super(opts);
        this.organizationInput = {
            name: "",
            logoUrl: "",
            newLogo: null,
            address: "",
            city: "",
            state: "",
            zip: "",
            domain: "",
            patientPortalName: "",
            allowDataAccessForPatientIdentification: true,
            allowDataAccessForDataDelivery: true,
            useAuthenticatorApp: false,
            patientPortalLink: "",
            vanitySubdomain: "",
            setupComplete: false,
            require21CFRPart11ForInformedConsents: false,
            defaultRequire21CFRPart11ForInformedConsents: false,
        };
        this.organizationsManager = opts.container.organizationsManager;
        this.environment = opts.container.environment;
    }
    edit() {
        this.editing = true;
    }
    updateOrganizationInput(update) {
        if (this.organizationInput === NOT_LOADED)
            return;
        this.organizationInput = { ...this.organizationInput, ...update };
    }
    async loadOrganization(organizationId, reload) {
        this.organizationInput = NOT_LOADED;
        if (reload) {
            await this.organizationsManager.waitForReloadOrganizations();
        }
        else {
            await this.organizationsManager.waitForValueOrganizations();
        }
        const organization = this.organizationsManager.getOrganization(organizationId);
        if (!organization || organization === NOT_LOADED)
            return;
        if (organization.type !== UserType.HEALTHCARE_ORGANIZATION)
            return;
        const { name, logoUrl, address, city, state, zip, domain, patientPortalName, allowDataAccessForPatientIdentification, allowDataAccessForDataDelivery, blockchainSigningType, patientPortalLink, vanitySubdomain, setupComplete, require21CFRPart11ForInformedConsents, defaultRequire21CFRPart11ForInformedConsents, } = organization;
        this.organizationInput = {
            name,
            logoUrl,
            newLogo: null,
            address: address !== null && address !== void 0 ? address : "",
            city: city !== null && city !== void 0 ? city : "",
            state: state !== null && state !== void 0 ? state : "",
            zip: zip !== null && zip !== void 0 ? zip : "",
            domain: domain !== null && domain !== void 0 ? domain : "",
            patientPortalName: patientPortalName !== null && patientPortalName !== void 0 ? patientPortalName : "",
            allowDataAccessForPatientIdentification,
            allowDataAccessForDataDelivery,
            useAuthenticatorApp: blockchainSigningType === BlockchainSigningType.SIGNING_APP,
            patientPortalLink: patientPortalLink !== null && patientPortalLink !== void 0 ? patientPortalLink : "",
            vanitySubdomain: vanitySubdomain !== null && vanitySubdomain !== void 0 ? vanitySubdomain : "",
            setupComplete: setupComplete !== null && setupComplete !== void 0 ? setupComplete : false,
            require21CFRPart11ForInformedConsents,
            defaultRequire21CFRPart11ForInformedConsents,
        };
    }
    async performUpdate() {
        if (this.organizationInput === NOT_LOADED || this.opts.mode === "new")
            return;
        const { domain } = this.organizationInput;
        await this.organizationsManager.updateOrganizationDetails(this.opts.organizationId, {
            type: UserType.HEALTHCARE_ORGANIZATION,
            domain,
        });
    }
    async performCreate(createInitialUserInput) {
        if (this.organizationInput === NOT_LOADED)
            throw new Error("organizationInput NOT_LOADED in create state");
        const { name } = this.organizationInput;
        const organizationId = await this.organizationsManager.createOrganization(name, UserType.HEALTHCARE_ORGANIZATION, createInitialUserInput);
        return organizationId;
    }
    get vanitySubdomainSuffix() {
        return `.${this.environment.WEB_ROOT_DOMAIN}`;
    }
}
__decorate([
    observable
], GlobalAdminHealthcareOrganizationFormModel.prototype, "organizationInput", void 0);
__decorate([
    computed
], GlobalAdminHealthcareOrganizationFormModel.prototype, "vanitySubdomainSuffix", null);
